export function getProductPrices({
  product,
  selectedVariant,
}: {
  product?: Distinct<TProduct>;
  selectedVariant?: {
    value: string;
    label: string;
  };
}): {
  price?: number;
  discountPrice?: number;
} {
  if (product?.variants && selectedVariant && !product.price) {
    const productVariant = product.variants.find(
      (product) => product._id === selectedVariant?.value
    );

    return {
      discountPrice: productVariant && productVariant.discountPrice,
      price: productVariant && productVariant.price,
    };
  }

  return { discountPrice: product?.discountPrice, price: product?.price };
}
